import * as React from "react";
import { util } from "../lib/Util";
import { FetchWithAuth } from "digimaker-ui/util";
import { Select } from "antd";

const { Option } = Select;

export default class Teacher extends React.Component<
  { mode: string; data?: any; onChange?: any },
  { subjects: any; selected: any }
> {
  constructor(props) {
    super(props);
    this.state = { subjects: [], selected: {} };
  }

  componentDidMount() {
    this.fetchSubjects();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(prevState.selected) != JSON.stringify(this.state.selected)
    ) {
      let name: Array<any> = [];
      let subject = this.state.subjects.find(
        (x) => x.id == this.state.selected.subject,
      );
      if (subject) {
        name.push(subject.name);
      }
      if (this.state.selected.intake) {
        name.push(this.state.selected.intake);
      }
      if (this.props.onChange) {
        this.props.onChange(this.state.selected, name);
      }
    }
  }

  fetchSubjects() {
    FetchWithAuth("icd/subject/list")
      .then((data) => {
        this.setState({
          subjects: data.data,
          selected: {
            ...this.state.selected,
            subject: data[0].id,
            intake: util.currentIntake(),
          },
        });
      })
      .catch((err) => {
        this.setState(() => {
          throw err;
        });
      });
  }

  render() {
    let intake = this.state.selected?.intake || util.currentIntake();

    if (this.props.mode == "view") {
      if (this.state.subjects && this.props.data) {
        let subject = this.state.subjects.find(
          (x) => x.id == this.props.data.subject,
        );
        if (subject) {
          return (
            <span>
              subject: {subject.name}, Intake: {this.props.data.intake}
            </span>
          );
        } else {
          return "";
        }
      } else {
        return "";
      }
    }

    return (
      <div>
        <div>
          <label>Subject:</label>
          <select
            className="form-control"
            onChange={(e) =>
              this.setState({
                selected: { ...this.state.selected, subject: e.target.value },
              })
            }
          >
            {this.state.subjects.map((item: any) => (
              <option value={item.id}>{item.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label>Intake:</label>
          <span>
            <Select
              defaultValue={intake[0]}
              style={{ width: "80px" }}
              onSelect={(value: any) =>
                this.setState({
                  selected: {
                    ...this.state.selected,
                    intake: value + "-" + intake.split("-")[1],
                  },
                })
              }
            >
              {util.intakeMonths().map((v) => (
                <Option value={v}>{v}</Option>
              ))}
            </Select>
            <Select
              defaultValue={intake.split("-")[1]}
              style={{ width: "80px" }}
              onSelect={(value: any) =>
                this.setState({
                  selected: {
                    ...this.state.selected,
                    intake: intake.split("-")[0] + "-" + value,
                  },
                })
              }
            >
              {util.intakeYears().map((v) => (
                <Option value={v}>{v}</Option>
              ))}
            </Select>
          </span>
        </div>
      </div>
    );
  }
}
